

import { Locale } from "./i18n";

export default {
    display: "English",
    code: "en",
    translation: {
        "arc.angle": "Angle",
        "arc.start": "Start",
        "axis.x": "X Axis",
        "axis.y": "Y Axis",
        "axis.z": "Z Axis",
        "body.arc": "Arc",
        "body.bolean": "Boolean",
        "body.box": "Box",
        "body.pyramid": "Pyramid",
        "body.cylinder": "Cylinder",
        "body.cone": "Cone",
        "body.sphere": "Sphere",
        "body.ellipse": "Ellipse",
        "body.circle": "Circle",
        "body.face": "Face",
        "body.fuse": "Fuse",
        "body.imported": "Imported",
        "body.line": "Line",
        "body.polygon": "Polygon",
        "body.prism": "Prism",
        "body.rect": "Rectangle",
        "body.revol": "Revolve",
        "body.sweep": "Sweep",
        "body.wire": "Wire",
        "box.dx": "Length",
        "box.dy": "Width",
        "box.dz": "Height",
        "body.editableShape": "Editable Shape",
        "body.meshNode": "Mesh Node",
        "body.multiShape": "Multi Shape",
        "circle.center": "Center",
        "circle.radius": "Radius",
        "ellipsoid.radiusX": "RadiusX",
        "ellipsoid.radiusY": "RadiusY",
        "ellipsoid.radiusZ": "RadiusZ",
        "ellipse.majorRadius": "majorRadius",
        "ellipse.minorRadius": "minorRadius",
        "command.arc": "Arc",
        "command.array": "Array",
        "command.bezier": "Bezier",
        "command.boolean.common": "Common",
        "command.boolean.cut": "Cut",
        "command.boolean.fuse": "Fuse",
        "command.box": "Box",
        "command.pyramid": "Pyramid",
        "command.cylinder": "Cylinder",
        "command.cone": "Cone",
        "command.copySubShape": "SubShape",
        "command.sphere": "Sphere",
        "command.ellipsoid": "Ellipsoid",
        "command.ellipse": "ellipse",
        "command.break": "Break",
        "command.chamfer": "Chamfer",
        "command.circle": "Circle",
        "command.copy": "Copy",
        "command.delete": "Delete",
        "command.document.new": "New Document",
        "command.document.open": "Open Document",
        "command.document.save": "Save",
        "command.document.saveAs": "Save As",
        "command.document.saveToFile": "Save To File",
        "command.explode": "Explode",
        "command.export": "Export",
        "command.faceable.isFace": "Face",
        "command.fillet": "Fillet",
        "command.fuse": "Fuse",
        "command.import": "Import",
        "command.line.isConnected": "Connected",
        "command.line": "Line",
        "command.mirror": "Mirror",
        "command.mode.repeat": "Repeat",
        "command.move": "Move",
        "command.newFolder": "New Folder",
        "command.newGroup": "New Group",
        "command.offset": "Offset",
        "command.polygon": "Polygon",
        "command.prism": "Prism",
        "command.rect": "Rectangle",
        "command.redo": "Redo",
        "command.removeFeature": "Remove Feature",
        "command.removeSubShapes": "Remove SubShapes",
        "command.revol": "Revol",
        "command.rotate": "Rotate",
        "command.section": "Section",
        "command.split": "Split",
        "command.sweep": "Sweep",
        "command.thickSolid": "Thick Solid",
        "command.toFace": "To Face",
        "command.toWire": "To Wire",
        "command.toShell": "To Shell",
        "command.toSolid": "To Solid",
        "command.trim": "Trim",
        "command.undo": "Undo",
        "common.angle": "Angle",
        "common.back": "Back",
        "common.cancel": "Cancel",
        "common.clone": "Clone",
        "common.color": "Color",
        "common.confirm": "Confirm",
        "common.general": "General",
        "common.length": "Length",
        "common.material": "Material",
        "common.matrix": "Matrix",
        "common.name": "Name",
        "common.normal": "Normal",
        "common.opacity": "Opacity",
        "common.thickness": "Thickness",
        "common.type": "Type",
        "entity.editable": "Editable Entity",
        "entity.parameter": "Parameter Entity",
        "error.default:{0}": "error: {0}",
        "error.input.cannotInputANumber": "Overlap with reference point, 1 number cannot be entered",
        "error.input.invalidNumber": "Please enter a valid number, separated by ,",
        "error.input.threeNumberCanBeInput": "Reference point is empty, only 3 numbers can be entered",
        "error.input.unsupportedInputs": "Exceeds the maximum number of inputs",
        "error.import.unsupportedFileType:{0}": "Unsupported file type: {0}",
        "error.export.noNodeCanBeExported": "No node can be exported",
        "file.format": "Format",
        "home.recent": "Drawings",
        "home.welcome": "Welcome to LuminiCAD",
        "items.header": "Items",
        "items.tool.delete": "Delete",
        "items.tool.expandAll": "Expand All",
        "items.tool.newFolder": "New Folder",
        "items.tool.unexpandAll": "Unexpand all",
        "line.end": "End",
        "line.start": "Start",
        "line.type.line": "Line",
        "line.type.xline": "XLine",
        "material.texture.image": "Image",
        "material.texture.rotation": "Rotation",
        "material.texture.wrapS": "Wrap S",
        "material.texture.wrapT": "Wrap T",
        "material.texture.repeat": "Repeat",
        "material.texture.offset": "Offset",
        "material.map": "Map",
        "material.specular": "Specular",
        "material.shininess": "Shininess",
        "material.emissive": "Emissive",
        "material.specularMap": "Specular Map",
        "material.normalMap": "Normal Map",
        "material.bumpMap": "BumpMap",
        "material.roughnessMap": "Roughness Map",
        "material.emissiveMap": "Emissive Map",
        "material.metalness": "Metalness",
        "material.metalnessMap": "Metalness Map",
        "material.roughness": "Roughness",
        "model.visible": "Visible",
        "operate.pickCircleCenter": "pick center, ESC key to cancel",
        "operate.pickFistPoint": "Pick first point, ESC key to cancel",
        "operate.pickNextPoint": "pick next point, ESC key to cancel",
        "operate.pickRadius": "input radius, ESC key to cancel",
        "polygon.points": "Points",
        "prompt.default":
            "Middle mouse button to pan the view, Shift + Middle button to rotate the view, Middle button to scroll the zoom view",
        "prompt.deleteDocument{0}": "Do you want to delete {0}?",
        "prompt.polygon.close": "Close",
        "prompt.saveDocument{0}": "Do you want to save the changes to {0}?",
        "prompt.select.edges": "Please select edges",
        "prompt.select.faces": "Please select faces",
        "prompt.select.models": "Please select models",
        "prompt.select.noModelSelected": "No model selected",
        "prompt.select.shape": "Please select shape",
        "prompt.select.vertexs": "Please select vertexs",
        "prompt.select.wires": "Please select wires",
        "properties.group.transform": "Transform",
        "properties.header": "Properties",
        "properties.multivalue": "Multi Value",
        "rect.dx": "Length",
        "rect.dy": "Width",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.boolean": "Bool",
        "ribbon.group.converter": "Convert",
        "ribbon.group.draw": "Draw",
        "ribbon.group.importExport": "File",
        "ribbon.group.modify": "Edit",
        "ribbon.group.other": "Other",
        "ribbon.group.selection": "Selection",
        "ribbon.group.tools": "Tools",
        "ribbon.group.workingPlane": "Working Plane",
        "ribbon.tab.draw": "Drawing",
        "ribbon.tab.file": "File",
        "ribbon.tab.startup": "Editor",
        "ribbon.tab.tools": "Tools",
        "snap.center": "Center",
        "snap.end": "End",
        "snap.intersection": "Intersection",
        "snap.mid": "Middle",
        "snap.perpendicular": "Perpendicular",
        "snap.nearest": "Nearest",
        "statusBar.snap": "Snap",
        "statusBar.tracking": "Tracking",
        "toast.command.{0}excuting": "Command {0} is runing",
        "toast.converter.error": "Converter error",
        "toast.converter.invalidColor": "The color is invalid",
        "toast.delete{0}Objects": "Deleted {0} objects",
        "toast.document.noActived": "No document actived",
        "toast.document.saved": "Document saved",
        "toast.downloading": "Downloading",
        "toast.excuting{0}": "Excuting {0}",
        "toast.fail": "Fail",
        "toast.read.error": "Read error",
        "toast.select.noSelected": "No selected",
        "toast.success": "Success",
        "transform.rotation": "Rotation",
        "transform.scale": "Scale",
        "transform.translation": "Translation",
        "vertex.point": "Point",
        "workingPlane.alignToPlane": "Align to plane",
        "workingPlane.set": "Set workplane",
        "test.performace": "Performace test",
        "chat.title": "AI Assistant",
        "chat.placeholder": "Type your CAD request...",
        "command.ai.chat": "AI Chat",
        "settings.title": "Settings",
        "settings.profile": "Profile",
        "settings.appearance": "Appearance",
        "settings.shortcuts": "Shortcuts",
        "settings.notifications": "Notifications",
        "settings.privacy": "Privacy",
        "settings.advanced": "Advanced",
        "settings.profile.name": "Full Name",
        "settings.profile.email": "Email Address",
        "settings.profile.bio": "Bio",
        "settings.profile.namePlaceholder": "Enter your name",
        "settings.profile.emailPlaceholder": "Enter your email",
        "settings.profile.bioPlaceholder": "Tell us about yourself",
        "settings.theme.title": "Theme",
        "settings.theme.light": "Light",
        "settings.theme.dark": "Dark",
        "workingPlane.toggleDynamic": "Toggle Dynamic Workplane",
        "workingPlane.fromSection": "From Section",
        "chat.shapesList.currentDocument": "Current Document Shapes",
        "chat.shapesList.allDocuments": "Shapes from Other Documents",
        "chat.shapesList.noDocument": "No active document to list shapes for.",
        "chat.shapesList.noStorage": "Storage not available to fetch documents.",
        "chat.shapesList.errorLoading": "Error loading shapes list.",
    },
} satisfies Locale;
